import React, { memo } from 'react';
import './CartShimmer.scss';

const FooterShimmer = ({ isCheckoutBtnVisible }) => {
    return (
        <div className="cart-footer-shimmer">
            <div className="cart-footer-top-shimmer">
                <div className="cart-footer-prices-shimmer">
                    <strong>Estimated subtotal:</strong>
                    <div className="cart-footer-total-shimmer">
                        <span className="cart-footer-section-shimmer shimmer-cart"></span>
                        <small className="charge-shimmer"></small>
                    </div>
                </div>
            </div>
            {isCheckoutBtnVisible && (
                <div className="cart-footer-actions-shimmer">
                    <div className="button button-block shimmer-cart"></div>
                </div>
            )}
        </div>
    );
};

export default memo(FooterShimmer);
